<template>
  <div>
    <div class="container">
      <div class="card alert-error">
        <h4 class="text-center"><strong>Ett fel har inträffat!</strong></h4>
        <p class="text-center">
          En text kunde inte laddas in från vårat innehållshanteringssystem, vi ber om ursäkt för besväret. <br />
          Om problemet kvarstår vänligen
          <a href="mailto:support@healthsolutions.se?subject=FHabian - {din titel}">mejla vår support</a>
          (<u>beskriv så utförligt som möjligt</u>)
        </p>
        <p class="text-center" v-if="err">
          Felmeddelande: <pre class="pre">{{ err }}</pre>
        </p>
        <div v-if="!err" class="clearfix"></div>
        <div class="text-center">
          <button class="btn w-300 btn-dark btn-lg" @click="$router.push('/')">Till startsidan</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'errorcontent',
  props: ['error'],
  components: {
  },
  data () {
    return {
      err: this.$props.error ? this.$props.error : ''
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.container {
  margin-left: 1vw;
  min-width: 50vw;
  max-width: 80vw;
}
.alert-error {
  background:#f16666;
  padding: 100px;
}
.pointer {
  cursor: pointer;
}
.siths-icon {
  width: 1.5vw;
  height: 1.5vw;
}
.card-header {
  padding: 50px;
}
.pre {
  padding: 10px;
  border: 1px solid gray;
  background: rgb(226, 219, 219);
  border-radius: 5px;
  margin: 10px auto 0 auto;
}
.w-300 {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorContent.vue